'use strict'

import React from 'react';
import uuid from 'uuid';

import FormattedContent from './FormattedContent.jsx';

function contrastColor(color) {
  var hexcolor=color.slice(1);
	var r = parseInt(hexcolor.substr(0,2),16);
	var g = parseInt(hexcolor.substr(2,2),16);
	var b = parseInt(hexcolor.substr(4,2),16);
	var yiq = ((r*299)+(g*587)+(b*114))/1000;
	return (yiq >= 128) ? 'black' : 'white';
}

export default class PopupDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state={id: uuid.v4()};
    this.switchMode=this.switchMode.bind(this);
  }

  switchMode(event) {
    this.props.selection.showDetails(this.props.selection.visible!==this.state.id ? this.state.id : undefined);
  }

  render() {
    var color=this.props.tenant!==undefined && this.props.tenant.design!==undefined && this.props.tenant.design.enabled && this.props.tenant.design.color!==undefined ? this.props.tenant.design.color : "#e41f1f";
    return (this.props.selection.visible===this.state.id) ? (
      <div onClick={this.switchMode.bind(this)} style={{position:"relative", cursor:"pointer", backgroundColor:"#e9e7e6"}}>
        <div style={{position:"absolute", right:34, top:-40, border:"1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, backgroundColor:"#ffffff", width:270,whiteSpace:"nowrap"}}>
          <div style={{backgroundColor:"#B0D7E7",  overflow:"hidden", textAlign:"left", textOverflow:"ellipsis", padding:"5px 5px 5px 15px", color:"#212121", borderRadius: "0px 0px 0px 0px", fontStyle: "normal"}}>{this.props.project!==undefined ? this.props.project.name : ""}</div>
          <div style={{display:"inline-block",fontStyle:"italic", padding:"5px 5px 5px 0px", width:210, textAlign:"left", whiteSpace:"normal", backgroundColor:"#FFFFFF"}}>
            {this.props.title!==undefined ? <div><b>{this.props.title}</b></div> : null}
            {this.props.date!==undefined ? <b>{this.props.date.slice(0,10)}: </b> : null}<FormattedContent value={this.props.content}/>
          </div>
          <div style={{backgroundColor:"#FFFFFF", display:"inline-block", verticalAlign:"top", paddingRight:0, paddingTop:5}}>
            {this.props.children}
          </div>
        </div>
      </div>
    ) : (
      <div onClick={this.switchMode.bind(this)} style={{cursor:"pointer"}}>
        {this.props.children}
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./views/components/PopupDescription.jsx